import { usePaginatedTable } from './usePaginatedTable';
import { createColumnHelper, ColumnDef } from '@tanstack/react-table';
import { LiquorShopsData } from '../types/LiquorShopsData';

type CommonData = LiquorShopsData;

const columnHelper = createColumnHelper<CommonData>();

const columns: ColumnDef<CommonData, any>[] = [
  // columnHelper.accessor('id', {
  //   header: 'id',
  //   cell: info => info.getValue(),
  // }),
  columnHelper.accessor('p_name', {
    header: '都道府県',
    cell: info => info.getValue(),
  }),
  // columnHelper.accessor('l_name', {
  //   header: '酒屋名',
  //   cell: info => info.getValue(),
  // }),
  {
    header: '酒屋名',
    accessorKey: 'l_name',
    cell: info => {
      const row = info.row.original;
      const url = row.url;
      const name = row.l_name;
      return url && url !== '-' ? (
        <a href={url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
          {name}
        </a>
      ) : (
        <span>{name}</span>
      );
    },
  },
  // columnHelper.accessor('url', {
  //   header: 'URL',
  //   cell: info => (
  //     <a href={info.getValue()} target="_blank" rel="noopener noreferrer">
  //       {info.getValue()}
  //     </a>
  //   ),
  // }),
];

export const useLiquorShopsTable = (
  url: string,
  initialPageIndex = 0,
  pageSize = 10
) => {
  return usePaginatedTable<CommonData>({
    url,
    columns,
    initialPageIndex,
    pageSize,
  });
};
